import React from "react";
import Sidebar from "../dashboard/Sidebar";

const Notifications = () => {
  return (
    <div className="component-main">
      <Sidebar active="notifications" />
      <p>Notifications Component</p>
    </div>
  );
};

export default Notifications;
